var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Icon, CountryList } from "../../UI";
import { Translate } from "../../I18N";

const style = { display: 'inline-block', width: '25px' };

export default class IconSelectorItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.item._id !== nextProps.item._id;
  }

  render() {
    const { item } = this.props;

    let icon = /*#__PURE__*/_jsx(Translate, {}, void 0, "No icon / flag");
    if (item.type === 'Icons') {
      icon = /*#__PURE__*/
      _jsx("span", { style: style }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: `${item._id}` })
      );

    }

    if (item.type === 'Flags') {
      const className = `fi fi-${CountryList.get(item._id).cca2}`.toLowerCase();
      icon = /*#__PURE__*/
      _jsx("span", { style: style }, void 0, /*#__PURE__*/
      _jsx("span", { className: className })
      );

    }

    return (/*#__PURE__*/
      _jsx("span", {}, void 0,
      icon,
      item.label
      ));

  }
}

IconSelectorItem.defaultProps = {
  item: undefined
};